module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point3_2-d35241a918364e9a4cc47925e51e88d5.jpg";